import { Pano } from "./display/Pano.js";

export class Application {
    constructor() {
        var panos: HTMLDivElement[] = (<any>document.querySelectorAll(".pano")) as HTMLDivElement[];
        panos.forEach((p) => {
            var pano = new Pano(p);
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Application();
});